<ng-container [ngSwitch]="numberOfImages">
    <ng-container *ngSwitchCase="1">
        <div class="one-image">
            <div *ngFor="let contentElement of gridCell.contentElements" [ngClass]="contentElement.containerClasses" [ngStyle]="{'background':''+contentElement?.containerBackground+''}">
                <img [src]="contentElement?.imgSrc"/>
            </div>            
        </div>
    </ng-container>
    <ng-container *ngSwitchCase="2">
        <div class="two-image">
            <div *ngFor="let contentElement of gridCell.contentElements" [ngClass]="contentElement.containerClasses" [ngStyle]="{'background':''+contentElement?.containerBackground+''}">
                <img [src]="contentElement?.imgSrc"/>
            </div>
        </div>
    </ng-container>
    <ng-container *ngSwitchDefault>
        <div class="multi-image">
            <div class="thumb-nav" #thumbNav>
                <div class="thumb-wrapper" *ngFor="let contentElement of gridCell?.contentElements;let i = index">
                    <img [src]="contentElement?.imgSrc" (click)="selectThumbNail(i)" class="thumb-nail-image"/>
                </div>
            </div>
            <div class="slide-wrapper" #collectionSlider>
                <div class="track" #track>
                    <div class="image-wrapper" *ngFor="let contentElement of gridCell?.contentElements" [ngClass]="contentElement.containerClasses" [ngStyle]="{'background':''+contentElement?.containerBackground+''}">
                        <img [src]="contentElement?.imgSrc"/>
                    </div>
                </div>
                <div class="slider-nav">
                    <button class="prev" (click)="slideRight()" #prev><i class="fa fa-angle-left"></i></button>
                    <button class="next" (click)="slideLeft()" #next><i class="fa fa-angle-right"></i></button>
                </div>
            </div>
            
        </div>
    </ng-container>
</ng-container>

